import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

 // Styling CSS akan disuntikkan langsung ke dalam <head> dokumen
 // untuk menjaga semuanya dalam satu file.
 const styles = `
     @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap');

     :root {
       --primary-color-start: #4F46E5;
       --primary-color-end: #818CF8;
       --scan-color: #4CAF50;
     }

     body {
       margin: 0;
     }

     .app-container {
         font-family: 'Inter', sans-serif;
         display: flex;
         flex-direction: column;
         justify-content: center;
         align-items: center;
         height: 100vh;
         width: 100%;
         background-color: #f0f2f5;
         color: #333;
         overflow: hidden;
     }
     
     /* Kartu untuk step awal dan akhir */
     .content-card {
         background: white;
         padding: 2.5rem;
         border-radius: 16px;
         box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
         text-align: center;
         max-width: 420px;
         width: 90%;
     }

     .content-card h2 {
         margin-top: 0;
         font-size: 1.75rem;
         color: #1a202c;
     }

     .content-card p {
         color: #555;
         margin-bottom: 2rem;
         line-height: 1.6;
     }

     /* Tombol utama */
     .action-button {
         background: linear-gradient(90deg, var(--primary-color-start), var(--primary-color-end));
         color: white;
         border: none;
         padding: 14px 28px;
         border-radius: 8px;
         cursor: pointer;
         font-size: 1rem;
         font-weight: 500;
         transition: all 0.3s ease;
         box-shadow: 0 4px 15px rgba(79, 70, 229, 0.4);
     }

     .action-button:hover {
         transform: translateY(-2px);
         box-shadow: 0 6px 20px rgba(79, 70, 229, 0.5);
     }
     
     /* Kontainer untuk step scanning */
     .scanning-container {
       display: flex;
       flex-direction: column;
       justify-content: center;
       align-items: center;
       width: 100%;
       gap: 2rem;
     }

     .instructions {
       text-align: center;
     }

     .instructions h2 { margin-bottom: 0.5rem; }
     .instructions p { margin-top: 0; color: #555; }
     
     /* Mockup Ponsel */
     .phone-mockup {
         position: relative;
         background: #1e1e1e;
         padding: 15px;
         box-shadow: 0 20px 40px rgba(0,0,0,0.3);
         border: 2px solid #444;
         transition: all 0.4s ease-in-out;
     }
     
     .phone-mockup.portrait {
         width: 16rem;
         height: 30rem;
         border-radius: 40px;
     }
     
     .phone-mockup.landscape {
         width: 26rem;
         height: 12rem;
         border-radius: 40px;
     }

     .camera-screen {
         background-color: #333;
         height: 100%;
         width: 100%;
         border-radius: 25px;
         position: relative;
         overflow: hidden;
         display: flex;
         justify-content: center;
         align-items: center;
     }
     
     .document-placeholder {
         opacity: 0.8;
         border-radius: 10px;
         object-fit: cover;
     }
     .document-placeholder.portrait-doc { width: 53%; height: 85%; }
     .document-placeholder.landscape-doc { width: 90%; height: auto; }
     
     .orientation-toggle {
       position: absolute;
       top: 15px;
       right: 15px;
       background-color: rgba(0, 0, 0, 0.6);
       color: white;
       border: 1px solid rgba(255,255,255,0.3);
       padding: 6px 12px;
       border-radius: 20px;
       cursor: pointer;
       z-index: 10;
       font-size: 12px;
       font-weight: 500;
     }

     /* Frame Scan */
     .scan-overlay {
         position: absolute;
         top: 0;
         left: 0;
         width: 100%;
         height: 100%;
         display: flex;
         justify-content: center;
         align-items: center;
     }

     .scan-frame {
         position: relative;
         box-sizing: border-box;
         transition: all 0.4s ease-in-out;
     }

     /* LOGIKA SESUAI PERMINTAAN */
     /* Frame untuk HP mode Tegak (menampilkan frame Miring/Lebar) */
     .scan-frame.frame-for-portrait-phone { width:  95%; height: 30%; }
     /* Frame untuk HP mode Miring (menampilkan frame Tegak/Tinggi) */
     .scan-frame.frame-for-landscape-phone { width: 55%; height: 90%; }
     
     .scan-frame::before, .scan-frame::after, .scan-corners::before, .scan-corners::after {
       content: '';
       position: absolute;
       width: 30px;
       height: 30px;
       border-color: var(--scan-color);
       border-style: solid;
     }

     .scan-frame::before { top: 0; left: 0; border-width: 4px 0 0 4px; border-radius: 4px 0 0 0; }
     .scan-frame::after { top: 0; right: 0; border-width: 4px 4px 0 0; border-radius: 0 4px 0 0; }
     
     .scan-corners { position: absolute; bottom: 0; width: 100%; height: 30px; left: 0; }
     .scan-corners::before { bottom: 0; left: 0; border-width: 0 0 4px 4px; border-radius: 0 0 0 4px; }
     .scan-corners::after { bottom: 0; right: 0; border-width: 0 4px 4px 0; border-radius: 0 0 4px 0; }

     /* Animasi Garis Scan */
     .scan-line {
         position: absolute;
         left: 0;
         width: 100%;
         height: 3px;
         background: linear-gradient(to bottom, transparent, var(--scan-color));
         animation: scan 2.5s ease-in-out infinite;
     }

     @keyframes scan {
         0%, 100% { top: 0; }
         50% { top: 99%; }
     }

     /* Animasi Fade-in */
     .fade-in {
       animation: fadeIn 0.5s ease-in-out;
     }
     @keyframes fadeIn {
         from { opacity: 0; transform: scale(0.98); }
         to { opacity: 1; transform: scale(1); }
     }
 `;

 // Komponen utama aplikasi
 export default function TutorialPage() {
     const [step, setStep] = useState('initial'); // 'initial', 'scanning', 'scanned'
     const [orientation, setOrientation] = useState('portrait'); // 'portrait', 'landscape'

     useEffect(() => {
         const styleSheet = document.createElement("style");
         styleSheet.type = "text/css";
         styleSheet.innerText = styles;
         document.head.appendChild(styleSheet);
         return () => document.head.removeChild(styleSheet);
     }, []);

     const startScanAnimation = () => setStep('scanning');
     const finishScan = () => setStep('scanned');
     const resetTutorial = () => setStep('initial');
     const toggleOrientation = () => {
         setOrientation(prev => (prev === 'portrait' ? 'landscape' : 'portrait'));
     };

     const renderInitialStep = () => (
         <div className="content-card fade-in">
             <h2>Tutorial Scan Dokumen</h2> 
             <p>Klik tombol di bawah untuk melihat simulasi scan dokumen interaktif.</p>
             <button className="action-button" onClick={startScanAnimation}>Mulai Simulasi</button>
         </div>
     );

     const renderScannedStep = () => (
         <div className="content-card fade-in">
             <h2>Scan Berhasil!</h2>
             <p>Simulasi scan telah selesai. Dokumen Anda berhasil "disimpan".</p>
             <button className="action-button" onClick={resetTutorial}>Coba Lagi</button>
         </div>
     );

     const renderScanningStep = () => (
         <div className="scanning-container fade-in">
             <div className="instructions">
                 <h2>Posisikan Dokumen</h2>
                 <p>Ubah mode orientasi dan pastikan dokumen di dalam area scan.</p>
             </div>

             <div className={`phone-mockup ${orientation}`}>
                 <div className="camera-screen">
                     <button className="orientation-toggle" onClick={toggleOrientation}>
                         {orientation === 'portrait' ? 'Mode Miring' : 'Mode Tegak'}
                     </button>
                     <img 
                         src={orientation === 'portrait' 
                             ? "https://placehold.co/400x250/e2e8f0/4a5568?text=Dokumen"
                             : "https://placehold.co/250x400/e2e8f0/4a5568?text=Dokumen"
                         }
                         alt="Contoh Dokumen"
                         className={`document-placeholder ${orientation === 'portrait' ? 'landscape-doc' : 'portrait-doc'}`}
                     />
                     <div className="scan-overlay">
                         <div className={`scan-frame ${orientation === 'portrait' ? 'frame-for-portrait-phone' : 'frame-for-landscape-phone'}`}>
                           <div className="scan-corners"></div>
                           <div className="scan-line"></div>
                         </div>
                     </div>
                 </div>
             </div>

             <button className="action-button" onClick={finishScan}>Lanjut</button>
         </div>
     );
     
     const renderStep = () => {
         switch (step) {
             case 'scanning': return renderScanningStep();
             case 'scanned': return renderScannedStep();
             case 'initial':
             default: return renderInitialStep();
         }
     };

     return (
         <div className="app-container">
             {renderStep()}
         </div>
     );
 }
